var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.step === 0)?_c('company-add',{on:{"next":function($event){_vm.step = 1}}}):_vm._e(),(_vm.step === 1)?_c('company-detail',{on:{"next":function($event){_vm.step = 2}}}):_vm._e(),(_vm.step === 2)?_c('company-complete'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }